import './Portfolio.css';

const ventures = [
  {
    name: 'D36 TV',
    tag: 'Media · Culture · UGC',
    accent: '#ffdd44',
    tagline: 'South Asian music television',
    desc: 'A lean-back television experience aggregating diverse programming for the South Asian diaspora. D36 TV curates artist-driven channels into a linear format built for Smart TVs — serving a 5.4M-strong audience with no dedicated music platform of their own.',
    channel: 'Smart TV platforms, diaspora communities, cultural media',
    stage: 'Live',
    statusClass: '',
    live: 'https://wall.d36.world/',
    liveLabel: 'Watch now ↗',
    details: [
      'Curated artist channels — flip through like classic music television',
      'Diverse programming aggregated for an underserved diaspora audience',
      'Built for Smart TVs — lean-back, channel-surfing experience',
    ],
  },
  {
    name: 'LA Receipts',
    tag: 'Civic · Data · LA',
    accent: '#E63946',
    tagline: 'Follow every dollar in Los Angeles',
    desc: 'A civic data platform that traces Los Angeles city finances from the adopted budget through the checkbook to the vendor who receives payment. LA Receipts aggregates eight categories of open city data — budgets, payroll, vendor spending, 311 services, public safety, housing, and homelessness programs — into one transparent, navigable deep dive.',
    channel: 'Residents, journalists, researchers, policymakers',
    stage: 'Live',
    statusClass: '',
    live: 'https://www.lareceipts.com/',
    liveLabel: 'Explore the data ↗',
    details: [
      'Budget-to-checkbook tracing — appropriations, actual spend, vendor payments',
      'Payroll and overtime analysis across every city department',
      '311, public safety, housing, and homelessness program tracking',
    ],
  },
  {
    name: 'Paul',
    tag: 'Live · Touring · AI',
    accent: '#C8E650',
    tagline: 'AI-native tour management',
    desc: 'An AI-native platform reimagining tour management from the ground up. Paul replaces the spreadsheets, group chats, and scattered tools that run modern tours with a persistent agent that handles routing, advancing, settlements, travel, and day-of-show logistics — giving artists, managers, and production teams one operating layer for the road.',
    channel: 'Artists, management companies, tour production, agencies',
    stage: 'Building',
    statusClass: 'b',
    live: 'https://paul-mu-vert.vercel.app/',
    liveLabel: 'See the vision ↗',
    details: [
      'Autonomous advancing — venues, tech specs, hospitality, day sheets',
      'Routing and travel optimization across cities, crews, and vehicles',
      'Real-time settlements, expense tracking, and post-show reporting',
    ],
  },
  {
    name: 'Cadence',
    tag: 'Music · Finance · AI',
    accent: '#10b981',
    tagline: 'Underwrite music catalogs in minutes',
    desc: 'Institutional-grade catalog valuation for the $44B music rights market. Cadence transforms raw royalty statements into complete valuations with Bayesian decay modeling, DCF analysis, and AI-generated investment memos — replacing weeks of manual Excel work with a repeatable, auditable pipeline.',
    channel: 'Labels, distributors, music investors, financiers',
    stage: 'Building',
    statusClass: 'b',
    live: 'https://cadence-bice.vercel.app/',
    liveLabel: 'See the vision ↗',
    details: [
      'CSV ingestion from any distributor — DistroKid, TuneCore, CD Baby',
      'Track-level decay modeling with confidence intervals',
      'Sensitivity heatmaps, target IRR pricing, risk analysis',
    ],
  },
  {
    name: 'Heart',
    tag: 'Music · Distribution · AI',
    accent: '#B2B89C',
    tagline: 'AI-native music distribution',
    desc: 'A persistent AI agent, personalized to each artist, that handles the entire operational backend of music distribution. Heart replaces forms and dashboards with an autonomous agent that ingests audio, constructs metadata, delivers to DSPs, monitors analytics, and tracks royalties — so the artist never thinks about infrastructure again.',
    channel: 'Music distributors, DSPs, artist teams',
    stage: 'Building',
    statusClass: 'b',
    live: 'https://heart-pitch.vercel.app/',
    liveLabel: 'See the vision ↗',
    details: [
      '10 autonomous agent actions per release — artists make only 2',
      'Full DDEX metadata construction, ISRC assignment, split management',
      'Continuous royalty tracking with discrepancy detection',
    ],
  },
  {
    name: 'Parda',
    tag: 'Music · Media · Superfandom',
    accent: '#1a1aff',
    tagline: 'Network architecture for superfandom',
    desc: 'The operating infrastructure a fandom network runs on. Parda gives an artist or a culture its own television network — curated linear channels, a shared always-on broadcast, and a direct-to-fan commerce ladder — capturing the willingness to pay that a flat streaming subscription can never price. Two networks are live in production, and the second was generated programmatically in four hours of run time.',
    channel: 'Artists, labels, cultural clusters, brand advertisers',
    stage: 'Live',
    statusClass: '',
    live: 'https://parda.tv/',
    liveLabel: 'See it ↗',
    details: [
      'Linear channels and a programmed guide — a deterministic broadcast every viewer shares',
      'Commerce ladder live: follow-gated drops, tips at 0%, paid unlocks at 15%',
      'A new financeable asset class — recurring artist-subscription revenue on rails Parda operates',
    ],
  },
  {
    name: 'Book Club',
    tag: 'Education · AI',
    accent: '#C8A92A',
    tagline: 'The infrastructure for trusted knowledge',
    desc: 'Transforms authoritative nonfiction books into production-ready AI learning applications. Book Club\'s 9-stage pipeline deploys interactive platforms in hours — with conversational RAG grounded in licensed content, branching decision scenarios, and mastery mechanics — distributed through schools, libraries, and enterprise L&D.',
    channel: 'Schools, libraries, publishers, enterprise L&D',
    stage: 'Building',
    statusClass: 'b',
    details: [
      'LEARN: Conversational AI with citations to specific chapters and pages',
      'DECIDE: Branching scenarios for high-stakes practice',
      'MASTER: Progress mechanics with proof-of-mastery credentials',
    ],
  },
  {
    name: 'Gordy',
    tag: 'Music · Business · AI',
    accent: '#A855F7',
    tagline: 'The teammate who never misses an email',
    desc: 'An AI agent that runs the business side of music. CC Gordy on a thread or forward a document and it reads the contracts, statements, and negotiations — organizing everything by artist, flagging risky terms, tracking every deadline, and drafting the response. The operations person a manager or independent artist could never afford to hire.',
    channel: 'Music managers, independent artists, labels, artist teams',
    stage: 'Live',
    statusClass: '',
    live: 'https://www.trygordy.com/',
    liveLabel: 'Try it ↗',
    details: [
      'Reads contracts and statements — red flags ranked by severity, with citations',
      'Files by artist and surfaces every deadline: options, payments, reversions',
      'Drafts agreements from lawyer-vetted templates and pushback emails in your voice',
    ],
  },
];

export default function Portfolio() {
  return (
    <>
      <section className="page-header">
        <div className="page-label">Portfolio</div>
        <h1 className="page-title">AI-native companies built from inside the industry.</h1>
      </section>

      <section className="portfolio-section">
        <div className="section-label">Active Ventures</div>
        <div className="venture-grid">
          {ventures.map(v => (
            <div className="venture-card" key={v.name}>
              <div className="vc-accent" style={{ background: v.accent }} />
              <div className="vc-content">
                <div className="vc-header">
                  <div>
                    <div className="vc-tag">{v.tag}</div>
                    <div className="vc-name">{v.name}</div>
                    <div className="vc-tagline">{v.tagline}</div>
                  </div>
                  <div className="vc-status"><span className={`sdot ${v.statusClass}`}></span> {v.stage}</div>
                </div>
                <div className="vc-desc">{v.desc}</div>
                <div className="vc-details">
                  {v.details.map((d, i) => (
                    <div className="vc-detail" key={i}>
                      <span className="vc-detail-dash" style={{ color: v.accent }}>—</span>
                      {d}
                    </div>
                  ))}
                </div>
                <div className="vc-footer">
                  <div className="vc-footer-block">
                    <div className="vc-footer-label">Built For</div>
                    <div className="vc-footer-value">{v.channel}</div>
                  </div>
                  {v.live && (
                    <a className="vc-live" href={v.live} target="_blank" rel="noreferrer">
                      {v.liveLabel}
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
